import React, { PureComponent } from 'react';
import bindAll from 'lodash.bindall';
import styles from './style.css';
import ModalManager from '../modal/modal-manager';
import ImgVideoModal from './img-video-modal';

class StepCardLineImg extends PureComponent {
    constructor(props) {
        super(props);
        bindAll(this, [
            // 'onDrag',
            // 'handleStop',
            // 'showTips'
            'handleClick'
        ]);
    }

    // componentDidMount() {
    //     event.on('NO_TALK', this.noSpeak)
    //     event.on('SPEAKING', this.good)
    // }

    // componentWillReceiveProps(nextProps) {
    //     console.log(nextProps)
    // }

    handleClick(item){
        ModalManager.open(ImgVideoModal, {
            onClose: () => { },
            url:item,
            type:'img'
        })
    }


    render() {
        const { contentImg } = this.props;
        
        const showImg = !contentImg.image.includes('https')? `https://pkcode.oss-cn-hangzhou.aliyuncs.com/scratch/guide-assets/${window.stepsRuntime.guideId}/${contentImg.image}`: contentImg.image;

        return (
            <div className={styles.chatImg} onClick={()=>this.handleClick(showImg)}>
                <img width={contentImg.width} height={contentImg.height} src={showImg}></img>
            </div>
        );
    }
}

export default StepCardLineImg;
